import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { CATEGORIES, SERVICES } from "@/data/site";
import { Reveal } from "@/components/Reveal";

export default function ServiceCards() {
  return (
    <div className="grid gap-px bg-border sm:grid-cols-2">
      {CATEGORIES.map((c, i) => {
        const s = SERVICES[c.slug];
        return (
          <Reveal key={c.slug} delay={i * 0.08}>
            <Link
              to={c.path}
              data-testid={`service-card-${c.slug}`}
              className="group relative block h-full min-h-[420px] overflow-hidden bg-background"
            >
              <div className="clip-frame absolute inset-0">
                <img src={s.image} alt={s.imageAlt} className="h-full w-full object-cover opacity-95 transition-opacity duration-700 group-hover:opacity-100" loading="lazy" />
                <div className="absolute inset-0 bg-gradient-to-t from-background via-background/70 to-background/10" />
              </div>
              <div className="relative z-10 flex h-full min-h-[420px] flex-col justify-end p-8 md:p-10">
                <span className="label mb-4">{s.kicker}</span>
                <div>
                  <h3 className="font-display text-4xl md:text-5xl">{c.name}</h3>
                  <p className="mt-3 max-w-sm text-sm text-muted-foreground">{s.headline}</p>
                  <span className="mt-6 inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.16em] text-foreground">
                    Explore <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" strokeWidth={1.5} />
                  </span>
                </div>
              </div>
            </Link>
          </Reveal>
        );
      })}
    </div>
  );
}
